export default __webpack_public_path__ + "static/media/schedule-facebook-image-posts.2b29f26a.svg";